import React, { useEffect, useState } from 'react';
import {MasterDataGrid } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import { Enums } from '@utils';
import FinancialError from './financial-error';
interface IFinancialSections{
    status: any;
    screen?: string;
    section: string;
    columns: any;
    saveTable?: any;
    calculateTotalRow?: any;
    sectionData: any
    tableAlert?: string;
    dataColumns: any;
    initialValidate: boolean;
}

const FinancialSections: React.FC<IFinancialSections> = ({status, screen, section, columns, saveTable, calculateTotalRow, sectionData, tableAlert, dataColumns, initialValidate}: IFinancialSections) => {
    const [auxData, setAuxData] = useState(null);
    const view: IFollowupSubproject = {
        state: {
            dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    const helpText = section == Enums.FollowupBasicFields.implementer ? presenter.followupLabels.get("helpFinancialImplementer") : 
                section == Enums.FollowupBasicFields.location ? presenter.followupLabels.get("helpFinancialLocation") :  
                section == Enums.FollowupBasicFields.adt ? presenter.followupLabels.get("helpFinancialAdt") :  
                section == Enums.FollowupBasicFields.sdc ? presenter.followupLabels.get("helpFinancialSdc") : "";

    const changeStyles = (parentGrid: any) => {
        if(parentGrid !== undefined){
            const element = parentGrid.element();
            const totals = element.querySelector(".dx-datagrid-total-footer div:last-child tbody tr") as HTMLElement;
            const totalHeader = element.querySelector(".dx-datagrid-total-footer table tbody tr") as HTMLElement;

            if(totals !== null){
                totals.childNodes.forEach((childNode: any) => {
                    childNode.style.borderColor = "rgba(0,0,0,0.1)";
                    childNode.style.backgroundColor = "rgba(255,240,230,0.8)";
                })
            }
            if(totalHeader !== null){
                totalHeader.childNodes.forEach((childNode: any) => {
                    childNode.style.borderColor = "rgba(0,0,0,0.1)";
                    childNode.style.backgroundColor = "rgba(255,240,230,0.8)";
                })
            }
        }
    }

    useEffect(() => {
        if((tableAlert === `${sectionData.id}-${section}` || !tableAlert || tableAlert === 'All') && sectionData?.data && columns) {
			let asd = getAuxData()
            setAuxData(asd)
        }
    }, [sectionData?.data, tableAlert, columns, initialValidate, presenter.stepTourFin]); 

    let msgInitialError = (section === Enums.FollowupBasicFields.implementer) ? presenter.followupLabels.get("completeImpInfo") :
        (section === Enums.FollowupBasicFields.location) ? presenter.followupLabels.get("completeLocInfo") :
        (section === Enums.FollowupBasicFields.adt) ? presenter.followupLabels.get("completeAdtInfo") : ''

    const getAuxData = () => {
		return (
            <div id={section === Enums.FollowupBasicFields.implementer ? "FinancialTourStep8" : section === Enums.FollowupBasicFields.adt ? "FinancialTourStep9" : ''} >
                <FinancialError 
                    section={section}
                    initialValidate={initialValidate || (status.CodigoDimension === Enums.FollowupState.planning && section === Enums.FollowupBasicFields.adt)}
                    checkFinancialValues={(item: any) => presenter.checkFinancialValues(item, status, section)}
                    msgInitialError={msgInitialError}
                    followupLabels={presenter.followupLabels}
                    tableAlert={tableAlert}
                    calculatedSumMonth={(item: any) => presenter.checkSumMonth(item, status?.CodigoDimension)} 
                    calculatedReqFields={(item: any) => presenter.checkReqFields(item, status)} 
                    gridId={`${sectionData.id}-${section}`} 
                    changeStyles={changeStyles}
                />
                {!sectionData.data?.length && 
                    <div style={{width:"100%", textAlign:"center", color:"red", padding:"1rem"}}>
                    { presenter.followupLabels.get("errorPOPInfo")}
                    </div>
                }
                {((section === Enums.FollowupBasicFields.implementer || section === Enums.FollowupBasicFields.location) && !sectionData.data?.length && initialValidate) &&
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>
                            {(section === Enums.FollowupBasicFields.implementer) ?
                                presenter.followupLabels.get("implementerMinRequired") : presenter.followupLabels.get("locationMinRequired")
                            }
                        </h6>
                    </div>
                }
                <MasterDataGrid 
                    id={`${sectionData.id}-${section}`}
                    dataSource={sectionData.data}
                    columns={columns}
                    allowCode={sectionData.data?.length ? screen : Enums.FollowupState.view}
                    saveTable={saveTable}
                    gridTitle={sectionData.staticTitle}
                    gridHelpId={`tooltip-${section}`}
                    gridHelpText={helpText}
                    gridProps={{
                        width: "100%",
                        scrolling:{mode: "standard" , rowRenderingMode: "standard"},
                        editing:{ mode: "batch", allowUpdating: true, allowAdding: false, allowDeleting: false},
                        summary: {
                            recalculateWhileEditing: true,
                            totalItems: presenter.getFinancialSummary(section),
                            calculateCustomSummary: (options) => calculateTotalRow(options, columns)
                        },
                    }}
                />
            </div>
        )
    }

    return (
        <>
            {auxData && auxData}
        </>
    )
}

export default FinancialSections;